<app-dialog-top>
    <div class="d-flex align-items-center">
        <span>
            <i class="fa-solid fa-upload fa-fw fa-lg me-2"></i>
        </span>
        <div class="">
            <p class="m-0 p-0 fs-6 lh-1">
                {{'COMMON.FILE_LIST.LABEL_ADD_FILES' | translate}}
            </p>
        </div>
    </div>
</app-dialog-top>

<div mat-dialog-content class="h-100 w-100">
    <app-file-list class="h-100 w-100"
        [showLabel]="false"
        [allowUpload]="parameters.allowUpload"
        [allowDownload]="parameters.allowDownload"
        [allowDelete]="parameters.allowDelete"
        [allowedContentTypes]="parameters.allowedContentTypes"
        [maxTotalFiles]="parameters.maxTotalFiles"
        [maxTotalBytes]="parameters.maxTotalBytes"
        [remoteFiles]="parameters.remoteFiles"
        [(localFiles)]="parameters.localFiles"
        [showRemoteFiles]="false"
    ></app-file-list>
</div>

<app-dialog-bottom (onSaveClick)="onSubmit($event)" [saveDisabled]="parameters.localFiles.length === 0" [saveText]="'COMMON.FILE_LIST.LABEL_UPLOAD_FILES' | translate"></app-dialog-bottom>
